import url_ from "asset-data:assets/galleries/test/L1000398-bw_47e4f02e52__800.jpg";
export const url = url_;